import { useEffect, useState } from "react";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { _single, _Store } from "../../../core/services/dataBean/EntityCatalog";
import { ListMenu } from "../../theme/Component/ListMenu";
import { BasicPage } from "../../theme/Component/BasicPage";
import { BasicTable, MASK_TEXT_NOWRAP } from "../../theme/Component/BasicTable";
import { ModalConfirm } from "../../theme/Component/ModalConfirm";
import { Modal } from "../../theme/Component/Modal";
import { toast } from "react-toastify";
import { _Product } from "../../../core/services/dataBean/EntityCatalogVdos";
import usePaginator from "../../theme/Component/usePaginator";
import { BasicSwitch } from "../../theme/Component/BasicSwitch";
import { OfficeEditor } from "../../erp/cellEditor/Office/OfficeEditor";
import { CostingCenterSelect } from "../../erp/cellEditor/CostingCenter/CostingCenterSelect";
import { AccountEditor } from "../../editor/AccountEditor";
import { SelectAccountantTree } from "../../contabilidad/catalogo-cuentas/AccountantTree/SelectAccountantTree";
import { SelectBusinessCore } from "../../erp/cellEditor/BusinessCore/SelectBusinessCore";
import { PrintJson } from "../../theme/Component/PrintJson";
import useModal, { MODAL_LG } from "../../theme/Component/hooks/useModal";
import { ShelfInventory } from "./ShelfInventory/ShelfInventory";

export const Store = () => {

    const { lista, setLista, bean, setBean, instance, update, handleChange, deleteItemVoid } = useDataBean(_Store);
    const paginador = usePaginator();

    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const modalShelf = useModal("Estatería/Ubicaciones Físicas", MODAL_LG);

    useEffect(() => {
        getLista()
    }, [paginador.page])

    const getLista = () => {
        instance.getStoresCatalog(null).then(
            (resp: any) => {
                setLista(resp)
            }
        ).catch(
            err => { console.log(err) }
        )
    }

    const editaItem = () => {
        update().then(
            (resp) => {
                getLista();
                setModal({ ...modal, "view": false })
            }
        ).catch(
            err => { console.log(err) }
        )
    }

    const deleteObjec = () => {
        deleteItemVoid(bean.IDStore).then(
            (resp) => {
                getLista();
                setModalC({ ...modalC, "view": false })
            }
        ).catch(
            err => { console.log(err) }
        )
    }

    const head = [
        { title: 'ID', property: 'IDStore', visible: true },
        { title: 'Nombre del Almacén', property: 'Description', visible: true },
        { title: 'Oficina', property: 'OfficeName', visible: true },
        { title: 'Centro de Costo', property: 'CostingCenterName', visible: true },
        { title: 'Unidad de Negocio', property: 'BusinessCoreName', visible: true },
        { title: 'Revisor', property: 'ReviewerName', visible: true },
        { title: 'Aprobador', property: 'ApproverName', visible: true },
        { title: 'Almacenista', property: 'StorerName', visible: true },
        { title: 'Utilizar ID Almacenista como Tercero', property: 'UseStorerIDForInventory', visible: true },
        { title: 'Bloquear Depreciación/Amortización', property: 'BlockDepreciationAmortization', visible: true },
        { title: 'Forzar Cuenta Contable para elementos de Inventario', property: 'UseAccountantIDForInventory', visible: true },
        { title: 'Cuenta Contable', property: 'AccountantIDName', visible: true },
        { title: 'Creado', property: 'IDEmployee', visible: true },
        { title: 'Fecha', property: 'Since', visible: true, mask: MASK_TEXT_NOWRAP },
    ]

    const create = () => {
        setBean({
            IDEmployee: _single.getAccountID(),
            UseStorerIDForInventory: false,
            BlockDepreciationAmortization: false,
        });
        setModal({ ...modal, "view": true, "name": "Agregar Almacen" });
    }

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { setModal({ ...modal, "view": true, "name": "Editar Almacen" }) } },
            { titulo: 'Estatería/Ubicaciones Físicas', icono: 'ri-list-check', visible: _single.canEdit(), evento: () => { modalShelf.open(); } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true, "name": `Eliminar Almacen` }) } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const [missingFields, setMissingFields] = useState<string[]>([]);

    const validateData = () => {
        console.log(bean)
        if (validateForm() > 0) {
            toast.error("Faltan campos obligatorios por completar");
            return;
        } else {
            editaItem();
        }
    }

    const validateForm = () => {
        const requiredFields = [
            "Description"
        ];

        let missing = [];
        for (let field of requiredFields) {
            if (bean[field] === null || bean[field] === undefined || bean[field] === "" || Number.isNaN(bean[field])) {
                missing.push(field);
            }
        }
        setMissingFields(missing);
        console.log(missing)
        return missing.length;
    };


    return (
        <BasicPage titulo="Catálogo de Almacenes" >
            <div className="row">
                <div className="col-md-12">
                    <BasicTable listButtons={listaBotones()} iconButtons={iconButtonsItem} head={head} body={lista} rowSet={setBean} />
                </div>

                <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteObjec}>
                    <strong>Eliminar Informacion de {bean.IDLine} - {bean.Description}</strong>
                </ModalConfirm>

                <Modal modal={modalShelf.modal} updateModal={modalShelf.setModal}>
                    <ShelfInventory Store={bean} />
                </Modal>

                <Modal modal={modal} updateModal={setModal} eventModal={validateData}>
                    <div className="row">
                        <div className="col-md-12">
                            <label className={`${missingFields.includes('Description') ? 'has-error' : ''}`}>Descripción</label>
                            <textarea name="Description" className="form-control" value={bean.Description} onChange={handleChange} />
                        </div>
                        <div className="col-md-6">
                            <SelectBusinessCore label='Unidad de Negocio' returnType="Object" idSelector={bean.IDBusinessCore} onChange={(e) => { setBean({ ...bean, "IDBusinessCore": e.IDBusinessCore, "BusinessCoreCodeName": `${e.Code} - ${e.Name}` }) }} />
                        </div>

                        <div className="col-md-6">
                            <OfficeEditor id={bean.IDOffice} onchange={(e) => { setBean({ ...bean, "IDOffice": e }) }} />
                        </div>
                        <div className="col-md-6">
                            <CostingCenterSelect fKey="Code" idSelector={bean.CostingCenter} label="Centro de Costo" onChange={(e) => { setBean({ ...bean, "CostingCenter": e }) }} />
                        </div>
                        <div className="col-md-6">
                            <AccountEditor idAccount={bean.IDReviewer} label="Revisor" onChange={(e) => { setBean({ ...bean, "IDReviewer": e.IDAccount }) }} />
                        </div>
                        <div className="col-md-6">
                            <AccountEditor idAccount={bean.IDApprover} label="Aprobador" onChange={(e) => { setBean({ ...bean, "IDApprover": e.IDAccount }) }} />
                        </div>
                        <div className="col-md-6">
                            <AccountEditor idAccount={bean.IDStorer} label="Almacenista" onChange={(e) => { setBean({ ...bean, "IDStorer": e.IDAccount }) }} />
                        </div>
                        <div className="col-md-6">
                            <label>Utilizar ID Almacenista como Tercero</label>
                            <BasicSwitch estado={bean.UseStorerIDForInventory} eventChange={(e) => { setBean({ ...bean, "UseStorerIDForInventory": e }) }} label=" " />
                        </div>
                        <div className="col-md-6">
                            <label >Bloquear Depreciación/Amortización</label>
                            <BasicSwitch estado={bean.BlockDepreciationAmortization} eventChange={(e) => { setBean({ ...bean, "BlockDepreciationAmortization": e }) }} label=" " />
                        </div>
                        <div className="col-md-6">
                            <label >Forzar Cuenta Contable para elementos de Inventario</label>
                            <BasicSwitch estado={bean.UseAccountantIDForInventory} eventChange={(e) => { setBean({ ...bean, "UseAccountantIDForInventory": e }) }} label=" " />
                        </div>
                        {bean.UseAccountantIDForInventory &&
                            <>
                                <div className="row">
                                    <div className="col-md-12">
                                        <SelectAccountantTree label='Cuenta Contable' idAccountant={bean.AccountantID} onChange={(e) => { setBean({ ...bean, "AccountantID": e.AccountantID, "AccountantIDStr": e.JsonCode }) }} />
                                    </div>
                                </div>

                            </>
                        }
                    </div>
                </Modal>
            </div>
        </BasicPage>
    )
}



